
import axios from 'axios';
import {getToken,getRefreshToken} from '../common';
import {
  HTTP_STATUS_TOKEN_EXPIRE,
  HTTP_STATUS_BAD_REQUEST,
  HTTP_STATUS_CONFLICT,
  HTTP_STATUS_INTERNAL_SERVER,
  HTTP_STATUS_OK,
  HTTP_STATUS_NOT_FOUND,
  BASE_PUNCHOUT_URL
} from '../constant';
const UUID = require('uuid-int');

const generator = UUID(511);

const getErrorText = (status) => {
  switch (status) {
    case 400:
      return HTTP_STATUS_BAD_REQUEST;
    case 401:
      return HTTP_STATUS_TOKEN_EXPIRE;
    case 404:
      return HTTP_STATUS_NOT_FOUND;
    case 409:
      return HTTP_STATUS_CONFLICT;
    case 500:
      return HTTP_STATUS_INTERNAL_SERVER;
    default:
      return '';
  }
};

let instance2 = axios.create({
  baseURL: BASE_PUNCHOUT_URL,
})

// request header
instance2.interceptors.request.use(
  (config) => {
    const token=getToken();
    // config.headers.Authorization = localStorage.getItem(ACCESS_TOKEN_KEY);
    config.headers = {"Access-Control-Allow-Origin": "*"} 
    config.headers = {"requesterID": "B2BFront"} 
    config.headers = {"requestTnxID": `B${generator.uuid()}`} 
    config.headers = {"requestDateTime": Date.now()} 
    config.headers = {"requestHash": generator.uuid()} //Date.now().toString(36)
    if(token)config.headers = {"Authorization": `Bearer ${token}`} //Date.now().toString(36)
    return config;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

  
// response parse
instance2.interceptors.response.use(
  (response) => {
    const apiResponse = {
      data: response.data,
      status: response.status,
      statusText: HTTP_STATUS_OK,
      headers: response.headers,
      config: response.config,
      message: response.data?.message,
      success: true
    };
    return apiResponse;
  },

  (error) => {
    if (error &&
      error?.response &&
      error?.response?.status === 401) {
      getRefreshToken();
    }
    const apiError = {
      data: null,
      status: error.status,
      statusText: getErrorText((error?.status) ?? 500),
      headers: error.headers,
      config: error.config,
      message: error.data?.message,
      success: false
    };
    return apiError;
});

export default instance2;